/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

// require('./bootstrap');

import Vue from "vue";
import Alpine from "alpinejs";
import focus from "@alpinejs/focus";
import collapse from '@alpinejs/collapse'
import "waypoints/lib/noframework.waypoints.min.js";

//on load is overwritten by one of the asset files so event listener is needed
window.addEventListener("load", () => {
    //TODO: move this to modules/index.js?
    require("./modules/animations")();
    require("./modules/scrolled-into-view").init();
});

document.addEventListener("DOMContentLoaded", function() {
    var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));

    if ("IntersectionObserver" in window) {
        let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    let lazyImage = entry.target;
                    lazyImage.src = lazyImage.dataset.src;
                    if (lazyImage.dataset.srcset !== undefined) {
                        lazyImage.srcset = lazyImage.dataset.srcset;
                    }
                    lazyImage.classList.remove("lazy");
                    lazyImageObserver.unobserve(lazyImage);
                }
            });
        });

        lazyImages.forEach(function(lazyImage) {
            lazyImageObserver.observe(lazyImage);
        });
    } else {
        // Possibly fall back to event handlers here
    }
});

import axios from "axios";
import VueAxios from "vue-axios";
import VueToastr from "vue-toastr";
import VModal from 'vue-js-modal';
import VueClickAway from "./directives/vue-click-away";
import vueDebounce from 'vue-debounce';
import { ZiggyVue } from 'ziggy';
import { Ziggy } from './ziggy';

window.Alpine = Alpine;

Alpine.plugin(focus);
Alpine.plugin(collapse)
Alpine.start();

Vue.use(VueAxios, axios);
Vue.use(VueToastr);
Vue.use(VModal);
Vue.directive("click-away", VueClickAway);
Vue.use(vueDebounce, {
    listenTo: 'input'
})
Vue.use(ZiggyVue, Ziggy);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

Vue.component(
    "ProductCategoryPage",
    require("./components/products/category-page/ProductCategoryPage").default
);
Vue.component(
    "ProductSlider",
    require("./components/products/category-overview/ProductSlider").default
);
Vue.component(
    "Subscription",
    require("./components/forms/Subscription").default
);
Vue.component(
    "GoogleMap",
    require("./components/google-maps/GoogleMap").default
);
Vue.component(
    "SearchBox",
    require("./components/search/SearchBox").default
);
Vue.component(
    "SearchDropdown",
    require("./components/search/SearchDropdown").default
);
Vue.component(
    "MobileSearchIcon",
    require("./components/search/MobileSearchIcon").default
);
Vue.component(
    "MobileSearch",
    require("./components/search/MobileSearch").default
);
Vue.component(
    "StockCheckSearchBox",
    require("./components/search/StockCheckSearchBox").default
);
Vue.component(
    "StockCheckTable",
    require("./components/search/StockCheckTable").default
);
Vue.component(
    "ParentStockCheck",
    require("./components/search/ParentStockCheck").default
);

// sentry
import * as Sentry from "@sentry/vue";

Sentry.init({
    Vue,
    dsn: process.env.MIX_SENTRY_DSN_PUBLIC,
});

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

if (document.getElementById("app")) {
    const app = new Vue({
        el: "#app",
    });
}

// fadeup animation
document.querySelectorAll(`.fadeup-group`).forEach((fadeupGroup) => {
    new Waypoint({
        element: fadeupGroup,
        handler(direction) {
            if (direction === `down`) {
                fadeupGroup.classList.add(`is-inview`)
                this.destroy()
            }
        },
        offset: `80%`,
    })
})
